import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { canonicalUrl, resolveRouteMeta, SITE_NAME } from "@/lib/routeMeta";

/**
 * Emits per-route <title>, description, canonical and og:* tags.
 * All values derive from the shared ROUTE_META registry so head tags and the
 * sitemap can never drift apart.
 */
export function RouteMeta() {
  const { pathname } = useLocation();
  const meta = resolveRouteMeta(pathname);
  const url = canonicalUrl(pathname);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={url} />
      {!meta.indexable && <meta name="robots" content="noindex" />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
    </Helmet>
  );
}
